export default "__VITE_ASSET__COhaTxGn__"